<template>
  <Toast />
  <div class="p-grid">
    <div class="p-col-12">
      <div class="p-d-flex p-ai-center p-jc-between p-flex-column p-flex-lg-row p-mb-1">
        <h5>Module Settings</h5>
        <div>
          <Button label="Dashboard" class="p-button-sm p-mr-2" @click="goToDashboard" icon="pi pi-th-large" />
          <Button label="Previous" class="p-button-sm p-mr-1" @click="goToPrevious" icon="pi pi-chevron-left" />
          <Button label="Next" icon="pi pi-chevron-right" @click="goToNext" class="p-button-sm" iconPos="right" />
        </div>
      </div>
      <div class="card">
        <div>
          <span class="subtext p-mt-2 p-text-capitalize">
            <h6>Admin Name : {{ this.localAdminName ? this.localAdminName : "-" }}</h6>
          </span>
        </div>
        <div class="p-mb-1">
          <div class="p-pt-2 p-px-3">
            <!-- Tourist Verification Option -->
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-12 p-mb-0">
                <div class="p-d-flex p-ai-center p-jc-between">
                  <div>
                    <label>Tourist Verification</label>
                  </div>
                  <div class="p-field-radiobutton p-mb-0">
                    <InputSwitch v-model="touristverificationstatus" />
                  </div>
                </div>
              </div>
              <Divider type="dashed" v-if="this.touristverificationstatus == true" />
              <div class="p-field p-col-12 p-md-12 p-mb-0" v-if="this.touristverificationstatus == true">
                <div class="p-d-flex p-ai-center p-jc-end">
                  <div class="p-d-flex p-flex-column">
                    <div class="p-field-radiobutton p-mb-2">
                      <RadioButton id="tourist_verification_yes_end" name="tourist_verification_yes_bill"
                        v-bind:value="1" v-model="touristverificationbillstatus"
                        :checked="touristverificationbillstatus == 1" @click="makeArrayByBillingType(1, 0)" />
                      <label for="tourist_verification_yes_end" class="p-mr-3">Bill to End Entity</label>
                      <RadioButton id="tourist_verification_yes_middle" name="tourist_verification_yes_bill"
                        v-bind:value="2" v-model="touristverificationbillstatus"
                        :checked="touristverificationbillstatus == 2" @click="makeArrayByBillingType(2, 0)" />
                      <label for="tourist_verification_yes_middle" class="p-mr-3">Bill to Middle Entity
                        <small>(Middle Entity Will Bill to End Entity)</small></label>
                      <RadioButton id="tourist_verification_yes_police" name="tourist_verification_yes_bill"
                        v-bind:value="3" v-model="touristverificationbillstatus"
                        :checked="touristverificationbillstatus == 3" @click="makeArrayByBillingType(3, 0)" />
                      <label for="tourist_verification_yes_police" class="p-mr-3">Bill to Police
                        <small>(Police will Bill to End Entity)</small></label>
                    </div>
                    <small class="p-invalid p-error" v-if="v$.touristverificationbillstatus.$error">{{
                      v$.touristverificationbillstatus.$errors[0].$message }}</small>
                  </div>
                </div>
              </div>
              <div class="p-field p-col-12 p-md-12 p-mb-0 p-d-flex p-ai-center p-jc-end"
                v-if="this.touristverificationbillstatus > 0 && touristverificationstatus">
                <div style="display: flex; align-items: center; width: 220px;">
                  <InputText id="percentagetouristverification" v-model="percentagetouristverification"
                    autocomplete="off" maxlength="3" placeholder="Enter Percentage" required="true"
                    :class="{ 'p-invalid': submitted && !officemobileno }" @keypress="onlyNumber($event)"
                    style="width: unset;" />
                  <i class="pi pi-percentage" v-if="percentagetouristverification"
                    style="position: relative; width: 20px; right: 25px; color: gray;"></i>
                </div>
                <div :style="{ width: '300px' }">
                  <Dropdown id="title" :style="{ width: '100%' }" v-model="touristverificationbillingtype"
                    :options="billingTypeListNew[0]" optionLabel="label" placeholder="Select Billing Type"
                    appendTo="body" :class="{ 'p-invalid': submitted && !officemobileno }">
                  </Dropdown>
                  <small class="p-invalid p-error" v-if="v$.touristverificationbillingtype.$error">{{
                    v$.touristverificationbillingtype.$errors[0].$message }}</small>
                </div>
              </div>
            </div>
            <Divider />
            <!-- Vehicle Rental Option -->
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-12 p-mb-0">
                <div class="p-d-flex p-ai-center p-jc-between">
                  <div>
                    <label>Vehicle Rental</label>
                  </div>
                  <div class="p-field-radiobutton p-mb-0">
                    <InputSwitch v-model="vehiclerentalstatus" />
                  </div>
                </div>
              </div>
              <Divider type="dashed" v-if="this.vehiclerentalstatus == true" />
              <div class="p-field p-col-12 p-md-12 p-mb-0" v-if="this.vehiclerentalstatus == true">
                <div class="p-d-flex p-ai-center p-jc-end">
                  <div class="p-d-flex p-flex-column">
                    <div class="p-field-radiobutton p-mb-2">
                      <RadioButton id="vehicle_rental_yes_end" name="vehicle_rental_yes_bill" v-bind:value="1"
                        v-model="vehiclerentalbillstatus" :checked="vehiclerentalbillstatus == 1"
                        @click="makeArrayByBillingType(1, 1)" />
                      <label for="vehicle_rental_yes_end" class="p-mr-3">Bill to End Entity</label>
                      <RadioButton id="vehicle_rental_yes_middle" name="vehicle_rental_yes_bill" v-bind:value="2"
                        v-model="vehiclerentalbillstatus" :checked="vehiclerentalbillstatus == 2"
                        @click="makeArrayByBillingType(2, 1)" />
                      <label for="vehicle_rental_yes_middle" class="p-mr-3">Bill to Middle Entity
                        <small>(Middle Entity Will Bill to End Entity)</small></label>
                      <RadioButton id="vehicle_rental_yes_police" name="vehicle_rental_yes_bill" v-bind:value="3"
                        v-model="vehiclerentalbillstatus" :checked="vehiclerentalbillstatus == 3"
                        @click="makeArrayByBillingType(3, 1)" />
                      <label for="vehicle_rental_yes_police" class="p-mr-3">Bill to Police
                        <small>(Police will Bill to End Entity)</small></label>
                    </div>
                    <small class="p-invalid p-error" v-if="v$.vehiclerentalbillstatus.$error">{{
                      v$.vehiclerentalbillstatus.$errors[0].$message }}</small>
                  </div>
                </div>
                <div class="p-field p-col-12 p-md-12 p-mb-0 p-d-flex p-ai-center p-jc-end"
                  v-if="this.vehiclerentalbillstatus > 0 && vehiclerentalstatus">
                  <div style="display: flex; align-items: center; width: 220px;">
                    <InputText id="percentagevehiclerental" v-model="percentagevehiclerental" autocomplete="off"
                      maxlength="3" placeholder="Enter Percentage" required="true" @keypress="onlyNumber($event)"
                      style="width: unset;" :class="{ 'p-invalid': submitted && !officemobileno }" />
                    <span v-if="percentagevehiclerental">
                      <i class="pi pi-percentage" style="position: relative; right: 25px; color: gray;"></i></span>
                  </div>
                  <div :style="{ width: '300px' }">
                    <Dropdown id="title" :style="{ width: '100%' }" v-model="vehiclerentalbillingtype"
                      :options="billingTypeListNew[1]" optionLabel="label" placeholder="Select Billing Type"
                      appendTo="body" :class="{ 'p-invalid': submitted && !officemobileno }">
                    </Dropdown>
                    <small class="p-invalid p-error" v-if="v$.vehiclerentalbillingtype.$error">{{
                      v$.vehiclerentalbillingtype.$errors[0].$message }}</small>
                  </div>
                </div>
              </div>
            </div>
            <Divider />
            <!-- Tenant Verification Option -->
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-12 p-mb-0">
                <div class="p-d-flex p-ai-center p-jc-between">
                  <div>
                    <label>Tenant Verification</label>
                  </div>
                  <div class="p-field-radiobutton p-mb-0">
                    <InputSwitch v-model="tenantverificationstatus" />
                  </div>
                </div>
              </div>
            </div>
            <Divider type="dashed" v-if="this.tenantverificationstatus == true" />
            <div class="p-field p-col-12 p-md-12 p-mb-0" v-if="this.tenantverificationstatus == true">
              <div class="p-d-flex p-ai-center p-jc-end">
                <div class="p-d-flex p-flex-column">
                  <div class="p-field-radiobutton p-mb-2">
                    <RadioButton id="tenant_verification_yes_end" name="tenant_verification_yes_bill" v-bind:value="1"
                      v-model="tenantverificationbillstatus" :checked="tenantverificationbillstatus == 1"
                      @click="makeArrayByBillingType(1, 2)" />
                    <label for="tenant_verification_yes_end" class="p-mr-3">Bill to End Entity</label>
                    <RadioButton id="tenant_verification_yes_middle" name="tenant_verification_yes_bill"
                      v-bind:value="2" v-model="tenantverificationbillstatus"
                      :checked="tenantverificationbillstatus == 2" @click="makeArrayByBillingType(2, 2)" />
                    <label for="tenant_verification_yes_middle" class="p-mr-3">Bill to Middle Entity
                      <small>(Middle Entity Will Bill to End Entity)</small></label>
                    <RadioButton id="tenant_verification_yes_police" name="tenant_verification_yes_bill"
                      v-bind:value="3" v-model="tenantverificationbillstatus"
                      :checked="tenantverificationbillstatus == 3" @click="makeArrayByBillingType(3, 2)" />
                    <label for="tenant_verification_yes_police" class="p-mr-3">Bill to Police
                      <small>(Police will Bill to End Entity)</small></label>
                  </div>
                  <small class="p-invalid p-error" v-if="v$.tenantverificationbillstatus.$error">{{
                    v$.tenantverificationbillstatus.$errors[0].$message }}</small>
                </div>
              </div>
              <div class="p-field p-col-12 p-md-12 p-mb-0 p-d-flex p-ai-center p-jc-end"
                v-if="this.tenantverificationbillstatus > 0 && tenantverificationstatus">
                <div style="display: flex; align-items: center; width: 220px;">
                  <InputText id="percentagetenantverification" v-model="percentagetenantverification" autocomplete="off"
                    maxlength="3" placeholder="Enter Percentage" @keypress="onlyNumber($event)" required="true"
                    autofocus :class="{ 'p-invalid': submitted && !officemobileno }" />
                  <span v-if="percentagetenantverification">
                    <i class="pi pi-percentage" style="position: relative; right: 25px; color: gray;"></i></span>
                </div>
                <div :style="{ width: '300px' }">
                  <Dropdown id="title" :style="{ width: '100%' }" v-model="tenantverificationbillingtype"
                    :options="billingTypeListNew[2]" optionLabel="label" placeholder="Select Billing Type"
                    appendTo="body" :class="{ 'p-invalid': submitted && !officemobileno }">
                  </Dropdown>
                  <small class="p-invalid p-error" v-if="v$.tenantverificationbillingtype.$error">{{
                    v$.tenantverificationbillingtype.$errors[0].$message }}</small>
                </div>
              </div>
            </div>
            <Divider />
            <!-- Migrant Labour Option -->
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-12 p-mb-0">
                <div class="p-d-flex p-ai-center p-jc-between">
                  <div>
                    <label>Migrant Labour</label>
                  </div>
                  <div class="p-field-radiobutton p-mb-0">
                    <InputSwitch v-model="migrantlabourstatus" />
                  </div>
                </div>
              </div>
            </div>
            <Divider type="dashed" v-if="this.migrantlabourstatus == true" />
            <div class="p-field p-col-12 p-md-12 p-mb-0" v-if="this.migrantlabourstatus == true">
              <div class="p-d-flex p-ai-center p-jc-end">
                <div class="p-d-flex p-flex-column">
                  <div class="p-field-radiobutton p-mb-2">
                    <RadioButton id="migrant_labour_yes_end" name="migrant_labour_yes_bill" v-bind:value="1"
                      v-model="migrantlabourbillstatus" :checked="migrantlabourbillstatus == 1"
                      @click="makeArrayByBillingType(1, 3)" />
                    <label for="migrant_labour_yes_end" class="p-mr-3">Bill to End Entity</label>
                    <RadioButton id="migrant_labour_yes_middle" name="migrant_labour_yes_bill" v-bind:value="2"
                      v-model="migrantlabourbillstatus" :checked="migrantlabourbillstatus == 2"
                      @click="makeArrayByBillingType(2, 3)" />
                    <label for="migrant_labour_yes_middle" class="p-mr-3">Bill to Middle Entity
                      <small>(Middle Entity Will Bill to End Entity)</small></label>
                    <RadioButton id="migrant_labour_yes_police" name="migrant_labour_yes_bill" v-bind:value="3"
                      v-model="migrantlabourbillstatus" :checked="migrantlabourbillstatus == 3"
                      @click="makeArrayByBillingType(3, 3)" />
                    <label for="migrant_labour_yes_police" class="p-mr-3">Bill to Police
                      <small>(Police will Bill to End Entity)</small></label>
                  </div>
                  <small class="p-invalid p-error" v-if="v$.migrantlabourbillstatus.$error">{{
                    v$.migrantlabourbillstatus.$errors[0].$message }}</small>
                </div>
              </div>
              <div class="p-field p-col-12 p-md-12 p-mb-0 p-d-flex p-ai-center p-jc-end"
                v-if="this.migrantlabourbillstatus > 0 && migrantlabourstatus">
                <div style="display: flex; align-items: center; width: 220px;">
                  <InputText id="percentagemigrantlabour" v-model="percentagemigrantlabour" autocomplete="off"
                    maxlength="3" placeholder="Enter Percentage" @keypress="onlyNumber($event)" required="true"
                    autofocus :class="{ 'p-invalid': submitted && !officemobileno }" />
                  <span v-if="percentagemigrantlabour">
                    <i class="pi pi-percentage" style="position: relative; right: 25px; color: gray;"></i></span>
                </div>
                <div :style="{ width: '300px' }">
                  <Dropdown id="title" :style="{ width: '100%' }" v-model="migrantlabourbillingtype"
                    :options="billingTypeListNew[3]" optionLabel="label" placeholder="Select Billing Type"
                    appendTo="body" :class="{ 'p-invalid': submitted && !officemobileno }">
                  </Dropdown>
                  <small class="p-invalid p-error" v-if="v$.migrantlabourbillingtype.$error">{{
                    v$.migrantlabourbillingtype.$errors[0].$message }}</small>
                </div>
              </div>
            </div>
            <Divider />
            <!-- Online FIR Option -->
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-12 p-mb-0">
                <div class="p-d-flex p-ai-center p-jc-between">
                  <div>
                    <label>Online FIR</label>
                  </div>
                  <div class="p-field-radiobutton p-mb-0">
                    <InputSwitch v-model="onlinefirstatus" />
                  </div>
                </div>
              </div>
            </div>
            <Divider type="dashed" v-if="this.onlinefirstatus == true" />
            <div class="p-field p-col-12 p-md-12 p-mb-0" v-if="this.onlinefirstatus == true">
              <div class="p-d-flex p-ai-center p-jc-end">
                <div class="p-d-flex p-flex-column">
                  <div class="p-field-radiobutton p-mb-2">
                    <RadioButton id="police_clearance_yes_end" name="police_clearance_yes_bill" v-bind:value="1"
                      v-model="onlinefirbillstatus" :checked="onlinefirbillstatus == 1"
                      @click="makeArrayByBillingType(1, 4)" />
                    <label for="police_clearance_yes_end" class="p-mr-3">Bill to End Entity</label>
                    <RadioButton id="police_clearance_yes_middle" name="police_clearance_yes_bill" v-bind:value="2"
                      v-model="onlinefirbillstatus" :checked="onlinefirbillstatus == 2"
                      @click="makeArrayByBillingType(2, 4)" />
                    <label for="police_clearance_yes_middle" class="p-mr-3">Bill to Middle Entity
                      <small>(Middle Entity Will Bill to End Entity)</small></label>
                    <RadioButton id="police_clearance_yes_police" name="police_clearance_yes_bill" v-bind:value="3"
                      v-model="onlinefirbillstatus" :checked="onlinefirbillstatus == 3"
                      @click="makeArrayByBillingType(3, 4)" />
                    <label for="police_clearance_yes_police" class="p-mr-3">Bill to Police
                      <small>(Police will Bill to End Entity)</small></label>
                  </div>
                  <small class="p-invalid p-error" v-if="v$.onlinefirbillstatus.$error">{{
                    v$.onlinefirbillstatus.$errors[0].$message
                  }}</small>
                </div>
              </div>
              <div class="p-field p-col-12 p-md-12 p-mb-0 p-d-flex p-ai-center p-jc-end"
                v-if="this.onlinefirbillstatus > 0 && onlinefirstatus">
                <div style="display: flex; align-items: center; width: 220px;">
                  <InputText id="percentageonlinefir" v-model="percentageonlinefir" autocomplete="off" maxlength="3"
                    placeholder="Enter Percentage" @keypress="onlyNumber($event)" required="true" autofocus
                    :class="{ 'p-invalid': submitted && !officemobileno }" />
                  <span v-if="percentageonlinefir">
                    <i class="pi pi-percentage" style="position: relative; width: 20px; right: 25px; color: gray;"></i>
                  </span>
                </div>
                <div :style="{ width: '300px' }">
                  <Dropdown id="title" :style="{ width: '100%' }" v-model="onlinefirbillingtype"
                    :options="billingTypeListNew[4]" optionLabel="label" placeholder="Select Billing Type"
                    appendTo="body" :class="{ 'p-invalid': submitted && !onlinefirbillingtype }">
                  </Dropdown>
                  <small class="p-invalid p-error" v-if="v$.onlinefirbillingtype.$error">{{
                    v$.onlinefirbillingtype.$errors[0].$message }}</small>
                </div>
              </div>
            </div>
            <Divider />
            <!-- Police Clearance Services Option -->
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-12 p-mb-0">
                <div class="p-d-flex p-ai-center p-jc-between">
                  <div>
                    <label>PCC (Police Clearance Services)</label>
                  </div>
                  <div class="p-field-radiobutton p-mb-0">
                    <InputSwitch v-model="policeclearancestatus" />
                  </div>
                </div>
              </div>
            </div>
            <Divider type="dashed" v-if="this.policeclearancestatus == true" />
            <div class="p-field p-col-12 p-md-12 p-mb-0" v-if="this.policeclearancestatus == true">
              <div class="p-d-flex p-ai-center p-jc-end">
                <div class="p-d-flex p-flex-column">
                  <div class="p-field-radiobutton p-mb-2">
                    <RadioButton id="police_clearance_yes_end" name="police_clearance_yes_bill" v-bind:value="1"
                      v-model="policeclearancebillstatus" :checked="policeclearancebillstatus == 1"
                      @click="makeArrayByBillingType(1, 5)" />
                    <label for="police_clearance_yes_end" class="p-mr-3">Bill to End Entity</label>
                    <RadioButton id="police_clearance_yes_middle" name="police_clearance_yes_bill" v-bind:value="2"
                      v-model="policeclearancebillstatus" :checked="policeclearancebillstatus == 2"
                      @click="makeArrayByBillingType(2, 5)" />
                    <label for="police_clearance_yes_middle" class="p-mr-3">Bill to Middle Entity
                      <small>(Middle Entity Will Bill to End Entity)</small></label>
                    <RadioButton id="police_clearance_yes_police" name="police_clearance_yes_bill" v-bind:value="3"
                      v-model="policeclearancebillstatus" :checked="policeclearancebillstatus == 3"
                      @click="makeArrayByBillingType(3, 5)" />
                    <label for="police_clearance_yes_police" class="p-mr-3">Bill to Police
                      <small>(Police will Bill to End Entity)</small></label>
                  </div>
                  <small class="p-invalid p-error" v-if="v$.policeclearancebillstatus.$error">{{
                    v$.policeclearancebillstatus.$errors[0].$message }}</small>
                </div>
              </div>
              <div class="p-field p-col-12 p-md-12 p-mb-0 p-d-flex p-ai-center p-jc-end"
                v-if="this.policeclearancebillstatus > 0 && policeclearancestatus">
                <div style="display: flex; align-items: center; width: 220px;">
                  <InputText id="percentagepoliceclearance" v-model="percentagepoliceclearance" autocomplete="off"
                    maxlength="3" placeholder="Enter Percentage" @keypress="onlyNumber($event)" required="true"
                    autofocus :class="{ 'p-invalid': submitted && !officemobileno }" />
                  <span v-if="percentagepoliceclearance">
                    <i class="pi pi-percentage" style="position: relative; right: 25px; color: gray;"></i></span>
                </div>
                <div :style="{ width: '300px' }">
                  <Dropdown id="title" :style="{ width: '100%' }" v-model="policeclearancebillingtype"
                    :options="billingTypeListNew[5]" optionLabel="label" placeholder="Select Billing Type"
                    appendTo="body" :class="{ 'p-invalid': submitted && policeclearancebillingtype }">
                  </Dropdown>
                  <small class="p-invalid p-error" v-if="v$.policeclearancebillingtype.$error">{{
                    v$.policeclearancebillingtype.$errors[0].$message }}</small>
                </div>
              </div>
            </div>
            <Divider />
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-12 p-mb-0">
                <div class="p-d-flex p-ai-center p-jc-between">
                  <div>
                    <label>Cloud Call Center</label>
                  </div>
                  <div class="p-field-radiobutton p-mb-0">
                    <InputSwitch  v-model="callsettingsstatus" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="p-d-flex p-jc-end p-mt-6">
            <Button v-if="!showLoader" label="Save" icon="pi pi-check" class="p-button-outlined"
              @click="submitModuleSetting" style="width: 90px"></Button>
            <Button v-show="showLoader" icon="pi pi-spin pi-spinner indigo-color" class="p-button-text p-ml-auto"
              style="width: 90px"></Button>
          </div>
        </div>
        <Toast />
      </div>
    </div>
  </div>
  <!-- confirmation modal start here -->
  <ConfirmDialog group="positioned"></ConfirmDialog>
  <!-- confirmation modal end here -->
</template>
<script>
import ApiService from "../../service/ApiService";
import useValidate from "@vuelidate/core";
import { requiredIf, helpers } from "@vuelidate/validators";
import { useRoute } from "vue-router";
import router from "@/router";
import CommonMixins from "../../mixins/common-mixins";

export default {
  mixins: [CommonMixins],
  data() {
    return {
      v$: useValidate(),
      showLoader: false,
      routeParam: "",
      localAdminName: "",
      submitted: false,
      officemobileno: "",
      // Label Yes No Status Radio Button start
      touristverificationstatus: false,
      vehiclerentalstatus: false,
      migrantlabourstatus: false,
      tenantverificationstatus: false,
      policeclearancestatus: false,
      onlinefirstatus: false,
      // Label Yes No Status Radio Button end
      // Bill Status Radio Button start
      touristverificationbillstatus: "",
      vehiclerentalbillstatus: "",
      migrantlabourbillstatus: "",
      tenantverificationbillstatus: "",
      policeclearancebillstatus: "",
      onlinefirbillstatus: "",
      // Bill Status Radio Button end
      // dropdown billing type start
      touristverificationbillingtype: "",
      vehiclerentalbillingtype: "",
      migrantlabourbillingtype: "",
      tenantverificationbillingtype: "",
      policeclearancebillingtype: "",
      onlinefirbillingtype: "",
      // dropdown billing type start
      billingTypeList: [
        { label: "Comprehensive", value: 1 },
        { label: "Component Wise", value: 2 },
        { label: "Comprehensive And Comprehensive", value: 11 },
        { label: "Comprehensive and Component wise", value: 12 },
        { label: "Component wise and Comprehensive", value: 21 },
      ],
      showloaderpage: false,
      existingModuleSetting: "",
      billingTypeListNew: [],
      // percentage key
      percentagetouristverification: "",
      percentagevehiclerental: "",
      percentagetenantverification: "",
      onlinefirpercentage: "",
      percentagemigrantlabour: "",
      percentageonlinefir: "",
      percentagepoliceclearance: "",
      // call center settings
      callsettingsstatus: false,
      callStatusFlag: false,
      tempStatus: false,
    };
  },
  ApiService: null,
  created() {
    this.ApiService = new ApiService();
  },
  mounted() {
    const route = useRoute();
    this.routeParam = route.params.adminSubId;
    this.localAdminName = localStorage.localAdminName;
    this.getModuleSetting({ maa1: this.routeParam });
  },
  validations() {
    return {
      touristverificationbillstatus: {
        requiredIf: helpers.withMessage(
          "Please select tourist verification option",
          requiredIf(this.touristverificationstatus == true)
        ),
      },
      vehiclerentalbillstatus: {
        requiredIf: helpers.withMessage(
          "Please select vehicle rental option",
          requiredIf(this.vehiclerentalstatus == true)
        ),
      },
      migrantlabourbillstatus: {
        requiredIf: helpers.withMessage(
          "Please select migrant labour option",
          requiredIf(this.migrantlabourstatus == true)
        ),
      },
      tenantverificationbillstatus: {
        requiredIf: helpers.withMessage(
          "Please select tenant verification option",
          requiredIf(this.tenantverificationstatus == true)
        ),
      },
      policeclearancebillstatus: {
        requiredIf: helpers.withMessage(
          "Please select PCC option",
          requiredIf(this.policeclearancestatus == true)
        ),
      },
      onlinefirbillstatus: {
        requiredIf: helpers.withMessage(
          "Please select Online FIR option",
          requiredIf(this.onlinefirstatus == true)
        ),
      },

      touristverificationbillingtype: {
        requiredIf: helpers.withMessage(
          "Please select billing type",
          requiredIf(this.touristverificationbillstatus > 0)
        ),
      },
      vehiclerentalbillingtype: {
        requiredIf: helpers.withMessage(
          "Please select billing type",
          requiredIf(this.vehiclerentalbillstatus > 0)
        ),
      },
      migrantlabourbillingtype: {
        requiredIf: helpers.withMessage(
          "Please select billing type",
          requiredIf(this.migrantlabourbillstatus > 0)
        ),
      },
      tenantverificationbillingtype: {
        requiredIf: helpers.withMessage(
          "Please select billing type",
          requiredIf(this.tenantverificationbillstatus > 0)
        ),
      },
      policeclearancebillingtype: {
        requiredIf: helpers.withMessage(
          "Please select billing type",
          requiredIf(this.policeclearancebillstatus > 0)
        ),
      },
      onlinefirbillingtype: {
        requiredIf: helpers.withMessage(
          "Please select billing type",
          requiredIf(this.onlinefirbillstatus > 0)
        ),
      },
    };
  },
  methods: {
    makeArrayByBillingType(e, i) {
      if (e == 1) {
        if (i == 0) {
          this.billingTypeListNew[0] = this.billingTypeList.slice(0, 2);
        } else if (i == 1) {
          this.billingTypeListNew[1] = this.billingTypeList.slice(0, 2);
        } else if (i == 2) {
          this.billingTypeListNew[2] = this.billingTypeList.slice(0, 2);
        } else if (i == 3) {
          this.billingTypeListNew[3] = this.billingTypeList.slice(0, 2);
        } else if (i == 4) {
          this.billingTypeListNew[4] = this.billingTypeList.slice(0, 2);
        } else if (i == 5) {
          this.billingTypeListNew[5] = this.billingTypeList.slice(0, 2);
        }
      } else {
        if (i == 0) {
          this.billingTypeListNew[0] = this.billingTypeList.slice(2);
        } else if (i == 1) {
          this.billingTypeListNew[1] = this.billingTypeList.slice(2);
        } else if (i == 2) {
          this.billingTypeListNew[2] = this.billingTypeList.slice(2);
        } else if (i == 3) {
          this.billingTypeListNew[3] = this.billingTypeList.slice(2);
        } else if (i == 4) {
          this.billingTypeListNew[4] = this.billingTypeList.slice(2);
        } else if (i == 5) {
          this.billingTypeListNew[5] = this.billingTypeList.slice(2);
        }
      }
    },

    getModuleSetting(item) {
      this.showloaderpage = true;
      this.ApiService.getModuleSetting(item).then((data) => {
        if (data.status == 200) {
          this.existingModuleSetting = data.data;
          if (this.existingModuleSetting.maa62 != 0) {
            this.touristverificationstatus = true;
            this.touristverificationbillstatus = this.existingModuleSetting.maa62;
            var touristverificationbillingtype = this.billingTypeList.filter(
              (item) => item.value == this.existingModuleSetting.maa63
            );
            this.touristverificationbillingtype = touristverificationbillingtype[0];
            this.makeArrayByBillingType(this.existingModuleSetting.maa62, 0);
            this.percentagetouristverification = this.existingModuleSetting.maa84;
          }

          if (this.existingModuleSetting.maa64 != 0) {
            this.vehiclerentalstatus = true;
            this.vehiclerentalbillstatus = this.existingModuleSetting.maa64;
            var vehiclerentalbillingtype = this.billingTypeList.filter(
              (item) => item.value == this.existingModuleSetting.maa65
            );
            this.vehiclerentalbillingtype = vehiclerentalbillingtype[0];
            this.makeArrayByBillingType(this.existingModuleSetting.maa64, 1);
            this.percentagevehiclerental = this.existingModuleSetting.maa85;
          }

          if (this.existingModuleSetting.maa66 != 0) {
            this.tenantverificationstatus = true;
            this.tenantverificationbillstatus = this.existingModuleSetting.maa66;
            var tenantverificationbillingtype = this.billingTypeList.filter(
              (item) => item.value == this.existingModuleSetting.maa67
            );
            this.tenantverificationbillingtype = tenantverificationbillingtype[0];
            this.makeArrayByBillingType(this.existingModuleSetting.maa66, 2);
            this.percentagetenantverification = this.existingModuleSetting.maa86;
          }

          if (this.existingModuleSetting.maa68 != 0) {
            this.migrantlabourstatus = true;
            this.migrantlabourbillstatus = this.existingModuleSetting.maa68;
            var migrantlabourbillingtype = this.billingTypeList.filter(
              (item) => item.value == this.existingModuleSetting.maa69
            );
            this.migrantlabourbillingtype = migrantlabourbillingtype[0];
            this.makeArrayByBillingType(this.existingModuleSetting.maa68, 3);
            this.percentagemigrantlabour = this.existingModuleSetting.maa87;
          }

          if (this.existingModuleSetting.maa70 != 0) {
            this.onlinefirstatus = true;
            this.onlinefirbillstatus = this.existingModuleSetting.maa70;
            var onlinefirbillingtype = this.billingTypeList.filter(
              (item) => item.value == this.existingModuleSetting.maa71
            );
            this.onlinefirbillingtype = onlinefirbillingtype[0];
            this.makeArrayByBillingType(this.existingModuleSetting.maa70, 4);
            this.percentageonlinefir = this.existingModuleSetting.maa88;
          }

          if (this.existingModuleSetting.maa72 != 0) {
            this.policeclearancestatus = true;
            this.policeclearancebillstatus = this.existingModuleSetting.maa72;
            var policeclearancebillingtype = this.billingTypeList.filter(
              (item) => item.value == this.existingModuleSetting.maa73
            );
            this.policeclearancebillingtype = policeclearancebillingtype[0];
            this.makeArrayByBillingType(this.existingModuleSetting.maa72, 5);
            this.percentagepoliceclearance = this.existingModuleSetting.maa89;
          }
          if (this.existingModuleSetting.maa97 != null) {
            this.callstatus = this.existingModuleSetting.maa97;
            this.callsettingsstatus = this.callstatus == 1 ? true : false;
            console.log("call settings status", this.callsettingsstatus);
          }
        }
        this.showloaderpage = false;
      });
    },
    submitModuleSetting() {
      this.submitted = true;
      let fields = {};
      fields["maa1"] = this.routeParam;
      if (this.touristverificationstatus) {
        fields["maa62"] = this.touristverificationbillstatus;
        fields["maa63"] = this.touristverificationbillingtype.value;
        fields["maa84"] = this.percentagetouristverification;
      } else {
        fields["maa62"] = 0;
        fields["maa63"] = null;
      }

      if (this.vehiclerentalstatus) {
        fields["maa64"] = this.vehiclerentalbillstatus;
        fields["maa65"] = this.vehiclerentalbillingtype.value;
        fields["maa85"] = this.percentagevehiclerental;
      } else {
        fields["maa64"] = 0;
        fields["maa65"] = null;
      }

      if (this.migrantlabourstatus) {
        fields["maa68"] = this.migrantlabourbillstatus;
        fields["maa69"] = this.migrantlabourbillingtype.value;
        fields["maa87"] = this.percentagemigrantlabour;
      } else {
        fields["maa68"] = 0;
        fields["maa69"] = null;
      }

      if (this.tenantverificationstatus) {
        fields["maa66"] = this.tenantverificationbillstatus;
        fields["maa67"] = this.tenantverificationbillingtype.value;
        fields["maa86"] = this.percentagetenantverification;
      } else {
        fields["maa66"] = 0;
        fields["maa67"] = null;
      }

      if (this.policeclearancestatus) {
        fields["maa72"] = this.policeclearancebillstatus;
        fields["maa73"] = this.policeclearancebillingtype.value;
        fields["maa89"] = this.percentagepoliceclearance;
      } else {
        fields["maa72"] = 0;
        fields["maa73"] = null;
      }

      if (this.onlinefirstatus) {
        fields["maa70"] = this.onlinefirbillstatus;
        fields["maa71"] = this.onlinefirbillingtype.value;
        fields["maa88"] = this.percentageonlinefir;
      } else {
        fields["maa70"] = 0;
        fields["maa71"] = null;
      }
      fields["maa97"] = this.callsettingsstatus == true ? 1 : 0
      this.v$.$validate();
      if (!this.v$.$error) {
        this.showLoader = true;
        this.ApiService.addModuleSettingsForBilling(fields).then((items) => {
          if (items.status == 200) {
            this.showLoader = false;
            var successMsg = items.message;
            this.submitted = false;
            this.$toast.add({
              severity: "success",
              summary: "Successful",
              detail: successMsg,
              life: 3000,
            });
            setTimeout(() => {
              this.goToDashboard();
            }, 3000);
          } else {
            this.showLoader = false;
            this.submitted = false;
            var errorMsg = items.message;
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: errorMsg,
              life: 3000,
            });
          }
        });
      }
    },
    goToDashboard() {
      router.push({
        name: "admindashboard",
        params: { adminId: this.routeParam },
      });
    },
    goToPrevious() {
      router.push({
        name: "adminconfig",
        params: { adminSubId: this.routeParam },
      });
    },
    goToNext() {
      router.push({
        name: "admincomponentcharges",
        params: { adminSubId: this.routeParam },
      });
    },
    onlyNumber(event) {
      if (!/^[0-9]$/.test(event.key)) {
        event.preventDefault();
      }
    },
    // confirmCallPermissions() {
    //   this.tempStatus = !this.callsettingsstatus;
    //   this.$confirm.require({
    //     group: 'positioned',
    //     message: 'Are you sure you want to change the call settings?',
    //     header: 'Confirm Call Settings Change',
    //     icon: 'pi pi-exclamation-triangle',
    //     position: 'top',
    //     rejectProps: {
    //       label: 'Cancel',
    //       severity: 'secondary',
    //       outlined: true
    //     },
    //     acceptProps: {
    //       label: 'Confirm',
    //       severity: 'danger'
    //     },
    //     accept: () => {
    //       this.callsettingsstatus = this.tempStatus; // Apply the intended toggle
    //       this.callStatusFlag = this.tempStatus;
    //     },
    //     reject: () => {
    //       this.$toast.add({ severity: 'error', summary: 'Cancelled', detail: 'Call Settings cancelled', life: 3000 });
    //     },
    //   });
    // },
    // onDialogHide() {
    //   this.callsettingsstatus = this.callStatusFlag;
    // }
  },
};
</script>
<style scoped lang="scss"></style>
